export enum EnumTypeNotification {
    ERREUR = 'ERREUR',
    INFO = 'INFO',
    SUCCESS = 'SUCCESS'
}
